/**
 * Normalize notification deep links for in-app navigation.
 * Email/AuthShell URLs must not be opened from the notifications center.
 */

const ALLOWED_PATH_PREFIXES = ['/parent/', '/coach/', '/rower/', '/admin/', '/home', '/sessions/'];

function isSafeRelativePath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  return ALLOWED_PATH_PREFIXES.some(
    (prefix) => path === prefix.replace(/\/$/, '') || path.startsWith(prefix)
  );
}

function stripSensitiveInboxParams(path: string): string {
  if (!path.startsWith('/parent/inbox')) return path;
  try {
    const parsed = new URL(path, 'https://app.glyyd.com');
    parsed.searchParams.delete('token');
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return path.split('?')[0];
  }
}

/**
 * Normalize notification deep links for in-app navigation.
 */
export function toInAppNotificationPath(deepLink: string | null | undefined): string | null {
  if (!deepLink || typeof deepLink !== 'string') return null;
  const trimmed = deepLink.trim();
  if (!trimmed) return null;

  let path = trimmed;
  if (!trimmed.startsWith('/')) {
    try {
      const parsed = new URL(trimmed);
      path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return null;
    }
  }

  if (path.startsWith('//')) return null;

  // Reconsent actions live in Inbox (portal chrome), not /parent/reconsent AuthShell.
  if (path.startsWith('/parent/reconsent')) {
    path = path.replace('/parent/reconsent', '/parent/inbox');
  }

  path = stripSensitiveInboxParams(path);

  if (!isSafeRelativePath(path)) return null;

  return path;
}
